import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

/**
 * Droplet-only helpers (legacy Monday/Zumos + order-create fallback).
 * Prefer digitalAppApi for new shop APIs.
 */
export const dropletOrderApi = createApi({
  reducerPath: 'dropletOrderApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://tpomobi.shop' }),
  endpoints: (builder) => ({
    createNewOrderBrowser: builder.mutation({
      query: (body) => ({
        url: '/createOrderAdminBrowser',
        headers: { 'Content-Type': 'application/json' },
        method: 'PUT',
        body,
      }),
    }),
    mondayChangeItemZumos: builder.mutation({
      query: (body) => ({
        url: '/mondayChangeItemZumos',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body,
      }),
    }),
    mondayAddItemZumos: builder.mutation({
      query: (body) => ({
        url: '/mondayAddItemZumos',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body,
      }),
    }),
    mondayDeleteItemZumos: builder.mutation({
      query: (body) => ({
        url: '/mondayDeleteItemZumos',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body,
      }),
    }),
    sendOrderChangeInfo: builder.mutation({
      query: (body) => ({
        url: '/sendOrderChangeInfo',
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const {
  useCreateNewOrderBrowserMutation,
  useMondayChangeItemZumosMutation,
  useMondayAddItemZumosMutation,
  useMondayDeleteItemZumosMutation,
  useSendOrderChangeInfoMutation,
} = dropletOrderApi
